import * as React from "react";
import {OutlinedInput, Stack, Typography} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({
    input: {
        '& input[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    },
});

const UpdateInformationBox = ({icon, alt, label, info, type, setter, helperText, error, id, iconMaterial}) => {
    const {mode} = useDarkMode();
    const classes = useStyles();
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={"space-evenly"} flexWrap={"wrap"}
               gap={{xs : 2, md : 2, lg : 0}}
        >
            {
                icon == 'none' ?
                    iconMaterial :
                    <img src={`/assets/icon/${icon}.png`} alt={alt} className={'profile-icon'}/>
            }
            <Typography
                width={180}
                color={mode.settings.textColor3}
                display={{xs : 'none', md : 'none', lg : 'block'}}
                component={'label'}
                id={'label-'+id}
                htmlFor={'input'+id}
            >
                {label}
            </Typography>
            <OutlinedInput
                size="small"
                id={'input'+id}
                aria-describedby={'label-'+id}
                inputProps={{
                    'aria-label': 'weight',
                }}
                type={type}
                value={info}
                style={{width: 200, height:35}}
                sx={{background :mode.settings.inputBackgroundColor, color:mode.settings.textColor3}}
                onChange={setter}
                error={error}
                className={classes.input}
            />
            <Typography style={{color : 'red', width: 250, marginLeft: 15}}>{helperText}</Typography>
        </Stack>
    )
}

export default UpdateInformationBox;
